export default __webpack_public_path__ + "static/media/MADHU_SAJJAN.b1c4c4e8.JPG";